// extracted by mini-css-extract-plugin
export default {"title":"SeasonInfo-title-briNN DescriptionListItemTitle-title-br1UE","description":"SeasonInfo-description-Ak3Gr undefined"};